import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';

/**
 * Service for handling Firebase multipath atomic updates
 * Centralizes the pattern of updating multiple paths in a single atomic operation
 */
@Injectable()
export class FirebaseMultipathUpdaterService {

    constructor(private afDB: AngularFireDatabase) { }

    /**
     * Mark a cotizacion as sent (fueEnviada = true)
     * Updates both cotizaciones and cotizacionesPorUsuario paths
     * @param cotizacionId - Cotizacion ID
     * @param usuarioId - User ID who created the cotizacion
     * @returns Promise when update completes
     */
    markCotizacionAsEnviada(cotizacionId: string, usuarioId: string): Promise<void> {
        const multipathUpdate = {};
        multipathUpdate['cotizaciones/' + cotizacionId + '/fueEnviada/'] = true;
        multipathUpdate['cotizacionesPorUsuario/' + usuarioId + '/' + cotizacionId + '/fueEnviada/'] = true;
        return this.afDB.object('/').update(multipathUpdate);
    }

    /**
     * Mark a cotizacion as read (fueLeida = true) and also mark as sent
     * Updates both cotizaciones and cotizacionesPorUsuario paths for both properties
     * @param cotizacionId - Cotizacion ID
     * @param usuarioId - User ID who created the cotizacion
     * @returns Promise when update completes
     */
    markCotizacionAsLeida(cotizacionId: string, usuarioId: string): Promise<void> {
        const multipathUpdate = {};
        multipathUpdate['cotizaciones/' + cotizacionId + '/fueLeida/'] = true;
        multipathUpdate['cotizacionesPorUsuario/' + usuarioId + '/' + cotizacionId + '/fueLeida/'] = true;
        multipathUpdate['cotizaciones/' + cotizacionId + '/fueEnviada/'] = true;
        multipathUpdate['cotizacionesPorUsuario/' + usuarioId + '/' + cotizacionId + '/fueEnviada/'] = true;
        return this.afDB.object('/').update(multipathUpdate);
    }

    /**
     * Generic multipath update for any paths
     * @param updates - Object with path keys and values to update
     * @returns Promise when update completes
     */
    update(updates: { [path: string]: any }): Promise<void> {
        return this.afDB.object('/').update(updates);
    }

    /**
     * Build multipath update object for cotizacion property
     * Helper to build the update object without executing it
     * @param cotizacionId - Cotizacion ID
     * @param usuarioId - User ID
     * @param propertyName - Property name to update (e.g., 'fueEnviada', 'fueLeida')
     * @param value - Value to set
     * @returns Multipath update object
     */
    buildCotizacionUpdate(
        cotizacionId: string,
        usuarioId: string,
        propertyName: string,
        value: any
    ): { [path: string]: any } {
        const multipathUpdate = {};
        multipathUpdate['cotizaciones/' + cotizacionId + '/' + propertyName + '/'] = value;
        multipathUpdate['cotizacionesPorUsuario/' + usuarioId + '/' + cotizacionId + '/' + propertyName + '/'] = value;
        return multipathUpdate;
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/helpers/firebase-multipath-updater.service.ts